// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3tEUT","name":"ConsentHeader_name__3Qfnh","birthday":"ConsentHeader_birthday__2fHK5","skeleton":"ConsentHeader_skeleton__321_P"};